import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { faGooglePlay } from "@fortawesome/free-brands-svg-icons";

import styles from "./ReviewItem.module.scss";

const ReviewItem = ({ review }) => {
	return (
		<div className={styles.reviewItem}>
			<div className={styles.reviewItem__header}>
				<img
					className={styles.reviewItem__avatar}
					src={review.avatar}
					alt={review.name}
				/>
				<div className={styles.reviewItem__info}>
					<div className={styles.reviewItem__name}>{review.name}</div>
					<div className={styles.reviewItem__rating}>
						{[...Array(Math.floor(review.rating))].map((_, i) => (
							<FontAwesomeIcon key={i} icon={faStar} />
						))}
						<span className={styles.reviewItem__ratingValue}>{review.rating}</span>
						<span className={styles.reviewItem__daysAgo}>{review.daysAgo} Days ago</span>
					</div>
				</div>
				<FontAwesomeIcon icon={faGooglePlay} size="lg" style={{ color: "green" }} />
			</div>
			<div className={styles.reviewItem__text}>{review.text}</div>
		</div>
	);
};

export default ReviewItem;
